import { Component, ViewChild } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-technician-dropdown-cell-editor',
  templateUrl: './technician-dropdown-cell-editor.component.html',
  styleUrls: ['./technician-dropdown-cell-editor.component.scss']
})
export class TechnicianDropdownCellEditorComponent implements ICellEditorAngularComp {
  params: any;
  technicianList: any[] = [];
  filteredTechnicianList: any[] = [];

  selectedTechCodes: string[] = [];
  searchValue: string = '';

  agInit(params: any): void {
    this.params = params;
    this.technicianList = params.technicianList || [];

    if (params.value) {
      this.selectedTechCodes = params.value.split(',').map(id => id.trim());
    }

    this.filteredTechnicianList = [...this.technicianList];
  }

  getValue(): any {
    return this.selectedTechCodes.join(', ');
  }

  onPanelOpen() {
    this.searchValue = '';
    this.filteredTechnicianList = [...this.technicianList];
  }

  filterTechnicians() {
    const lower = this.searchValue.toLowerCase();
    this.filteredTechnicianList = this.technicianList.filter(t =>
      t.fullName.toLowerCase().includes(lower)
    );
  }

  toggleTechnician(code: string, selectRef: MatSelect) {
    const index = this.selectedTechCodes.indexOf(code);
    if (index > -1) {
      this.selectedTechCodes.splice(index, 1);
    } else {
      this.selectedTechCodes.push(code);
    }

    // Update grid immediately
    this.params.node.setDataValue(this.params.column, this.getValue());
  }

  getSelectedTechNames(): string {
    return this.selectedTechCodes
      .map(code => {
        const tech = this.technicianList.find(t => t.employeeCode === code);
        return tech ? tech.fullName : code;
      })
      .join(', ');
  }
}
